var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7013 8.63124L2.36906 0.29912C2.17634 0.106252 1.91909 0 1.64478 0C1.37047 0 1.11321 0.106252 0.920498 0.29912L0.306883 0.912582C-0.0923997 1.31232 -0.0923997 1.96201 0.306883 2.36114L7.3037 9.35796L0.29912 16.3625C0.106404 16.5554 0 16.8125 0 17.0867C0 17.3611 0.106404 17.6182 0.29912 17.8113L0.912734 18.4246C1.1056 18.6174 1.36271 18.7237 1.63702 18.7237C1.91132 18.7237 2.16858 18.6174 2.3613 18.4246L10.7013 10.0848C10.8945 9.89135 11.0006 9.63303 11 9.35842C11.0006 9.08274 10.8945 8.82457 10.7013 8.63124Z",
    fill: "#ADB7BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.7a863523553b858e03ae4a2cbe013454.svg";
export { ForwardRef as ReactComponent };